// import React, { useState } from 'react'
// import Userans_check from '../../Download/User_check'
// import '../../Download/Download'
// import Show from '../../Download/Show'
// import PercentageAdd from '../../Award/PercentageAdd'
// import Bladge from '../../Award/Bladge'
import Show from '../../Download/Show';
import React, { useState, useEffect } from 'react';
import '../../../../Style/online-train/form.css'
import PercentageAdd from '../../Award/PercentageAdd'
import Bladge from '../../Award/Bladge'
import Userans_check from '../../Download/User_check'
const SetFun = ({ mat, row, ques, dic, dicrange, file, storfl }) => {
  const [ans, setans] = useState([])
  const [getans, getansinp] = useState()
  const [start, setStart] = useState(0)
  const [count, setcount] = useState(0)
  // const [start, setStart] = useState(0)
  const [last, islast] = useState(0)
  const [hidestart, sethidestart] = useState(0)
  const [index1, setindex1] = useState(true)
  const [list, setlist] = useState([])
  const [checkans, setcheckans] = useState(0)
  let dis = []
  const [isans, setisans] = useState(1)

  const [currentRow, setCurrentRow] = useState(0);
  const [Shows, setShows] = useState(0);
  const [displayedRow, setDisplayedRow] = useState([]);
  function firstcall() {
    setStart(1)
if (dic) {
  if (count < ques) {
    if (window.speechSynthesis.speaking) {
      window.speechSynthesis.cancel();
    }
    window.speechSynthesis.cancel();

    let dis = [];  // Ensure this is reset here
    for (let i = 0; i < row; i++) {
      const val = mat[count][i];
      if (val > 0) {
        dis.push("plus", val.toString());
      } else if (val < 0) {
        dis.push("minus", Math.abs(val).toString());
      } else {
        dis.push("zero");
      }
    }

    const voice = window.speechSynthesis.getVoices();
    const utterance = new SpeechSynthesisUtterance(dis.join(" "));
    dicrange ? utterance.rate = dicrange : utterance.rate = 1;
    window.speechSynthesis.speak(utterance);
    dis = []
    setcount(1);
  }
  sethidestart(true);
} else {
  islast(true);
}
  }
  function speak(event) {
  event.preventDefault();
  setStart(1);

  if (dic) {
    if (count < ques) {
      if (window.speechSynthesis.speaking) {
        window.speechSynthesis.cancel();
      }
      window.speechSynthesis.cancel();

      let dis = [];  // Ensure dis is initialized correctly
      let temp;

      for (let i = 0; i < row; i++) {
        temp = mat[count][i];
        if (temp > 0) {
          dis.push("plus", temp.toString());
        } else if (temp < 0) {
          dis.push("minus", Math.abs(temp).toString());
        } else {
          dis.push("zero");
        }
      }

      const voice = window.speechSynthesis.getVoices();
      const utterance = new SpeechSynthesisUtterance(dis.join(" "));
      dicrange ? utterance.rate = dicrange : utterance.rate = 1;
      window.speechSynthesis.speak(utterance);

      setcount(count + 1);
      dis = [];  // Reset for next use
      ans.push(getans);
      getansinp('');
    } else {
      ans.push(getans);
      getansinp('');
      islast(true);
    }
  }
}

  React.useEffect(() => {
    setDisplayedRow(mat[currentRow]);
  }, [currentRow, mat]);
  function DisplayNum() {
    for (let i = 0; i < row; i++) {
      list.push(mat[0][i])
    }
    console.log(list)
    sethidestart(true)
  }
  const DisplayNumNExt = (event) => {
    event.preventDefault()
    setindex1(false)
    if (currentRow < ques - 1) {
      ans.push(getans)
      getansinp('')
      setCurrentRow(currentRow + 1);
    } else {
      ans.push(getans)
      getansinp('')
      islast(true)
    }
  };
  return (
    <div className='card-show-download'>
      <div className={start && dic ? 'dic-input' : "dic-hide-input"}>
        <form onSubmit={speak} className='input-form'>
          <div className={last ? "hide-final" : "input"}>
            <input type='number' value={getans} className="box" onChange={(e) => { getansinp(e.target.value); }} id='input' required />
          </div>
          <div className='in'>
            <input type='submit' className={last ? "hide-final box" : "box bt-purple btn"} value="Next" />
          </div>
        </form>
        <div className={last ? "mark-card" : "hide-final"}>
          <div className='mark-card-1'>
            <button className={Shows ? "" : "bt-purple"} onClick={() => { Shows ? setShows(0) : setShows(1) }}>{Shows ? '' : "Show"}</button>
            <div className={Shows ? "display-ans" : "hide-btn"}>
              {/* <button className='X-btn-show' onClick={() => { setShows(0) }}>X</button> */}
              <Show {...{ row, mat, ques, ans }} />
            </div>
          </div>
          <div className='mark-card-2'>
            <Userans_check {...{ mat, ques, row, ans,ch:"a", last, file, storfl ,isans }} />
          </div>
          <PercentageAdd {...{mat, ques, row, ans ,ch:"a",last }} />
          {/* <PercentageAdd {...{ mat, ques, row, ans }} /> */}
        </div>
      </div>
      <div className={start && !dic ? 'dic-input' : "dic-hide-input"}>
        <form onSubmit={DisplayNumNExt} className='input-form'>
          <div className={last ? "hide-final" : "main-card"}>
            <div className='iner-main-card'>
              {displayedRow && displayedRow.map((item) => {
                return <h1 className='dis-ele'>{item}</h1>
              })}
              {index1 ? list.map((i) => {
                return <h1 className='dis-ele'>{i}</h1>
              }) : null}
            </div>
          </div>
          <div className={last ? "hide-final" : "input"}>
            <input type='number' className='box' value={getans} onChange={(e) => { getansinp(e.target.value); }} id='input' required />
          </div>
          <div className='in'>
            <input type='submit' className={ last ? "hide-final  box  " : " box bt-purple btn"} value="Next" />
          </div>
        </form>
        <div className={last ? "mark-card" : "hide-final"}>
          <div className='mark-card-1'>
            <button className={Shows ? "" : "bt-purple"} onClick={() => { Shows ? setShows(0) : setShows(1) }}>{Shows ? '' : "Show"}</button>
            <div className={Shows ? "display-ans" : "hide-btn"}>
              {/* <button className='X-btn-show' onClick={() => { setShows(0) }}>X</button> */}
              <Show {...{ row, mat, ques, ans }} />
            </div>
          </div>
          <div className='mark-card-2'>
            <Userans_check {...{ mat, ques, row, ans,ch:"a", last, file, storfl,isans }} />
          </div>
          <PercentageAdd {...{ mat, ques, row, ans ,ch:"a",last }} />
        </div>
      </div>
      <div className={last ? "show-bladge" : "hide-bladge"}>
        <Bladge {...{ mat, ques, row, ans , ch:"a",last }} />
      </div>
      <button className={hidestart ? "hide-btn" : "bt-purple"} onClick={() => { setStart(true); dic ? firstcall() : DisplayNum() }}>Start!</button>
    </div>
  )
}
export default SetFun